/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';

// utils
import {
  Translations,
  convertStringToArray,
  electOwningCase,
  getProjectStatus,
  shoudlDisableAllCaseBodyFooterBtns,
  shoudlDisableCancelBtn,
  shoudlEnableGenerateDraftBtn,
  shouldDisableDocumentationTab
} from '../../../utils';
// constant
import { CASE_STATUS_LEVEL_LOOKUP_TABLE } from '../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../restClient';
// children
import Banner from '../../common/Banner/';
import NavigationList from '../../common/NavigationList/';
import SimpleDropdown from '../../common/SimpleDropdown';
//action Creator
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
import { cryptoPass } from '../../../utils';
import { updateCasesWithStatus } from '../../createAcase/actions/actionCreator';
import { updateDarkTitleBarCaseStatus } from '../../layouts/actions/actionCreator';
import {
  disableAllCaseBodyFooterBtns,
  disableCaseBodyFooterBtn,
  disableTab,
  enableCaseBodyFooterBtn,
  enableTab,
  resetCurrentProductAch,
  resetcurrentProductCorporateCard,
  setGslAgent,
  setProductsDetails,
  setTabsStatus
} from '../actions/actionCreator';

//style
import Tooltip from '../../common/Tooltip';
import './styles.css';

class ProductRequests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      bannersVisibility: {},
      entityFilterSelection: 'all',
      pageJson: {},
      dropDownShow: false
    }
    this.selectedEntity = false;
  }
  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }
  componentWillMount() {
    document.title = `${"Product Requests"} - ${'HSBC GLCM'}`;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      taxonomyHostClient(this.translations(this.state.pageJson.par.navigation_list_accountList.accountTaxonomy))
        .then(({ data }) => {
          this.setState({ currentListAccountCountries: data.responseData.countryTaxonomy.classificationNodes })
        })

      taxonomyHostClient(this.translations(this.state.pageJson.par.navigation_list_eChannelList.countryTaxonomy))
        .then(({ data }) => {
          this.setState({ currentListCountries: data.responseData.classificationNodes })
        })
    }
  }

  componentDidMount() {
    this.getProductRequest()
  }

  getProductRequest = async () => {
    if (this.props.history.action === 'POP') {
      this.props.resetCurrentProductAch();
      this.props.resetcurrentProductCorporateCard();
    }
    let tab = await cryptoPass('product-tab',);
    window.sessionStorage.removeItem("tab");
    window.localStorage.setItem('tab', tab);

    aemHostClient("/aemData/formData/json_product-requests")
      .then(({ data, status }) => {
        this.setState({
          pageJson: data
        });
        taxonomyHostClient(this.translations(this.state.pageJson.par.navigation_list_accountList.accountTaxonomy))
          .then(({ data }) => {
            this.setState({ currentListAccountCountries: data.responseData.countryTaxonomy.classificationNodes })
          })
        taxonomyHostClient(this.translations(this.state.pageJson.par.navigation_list_eChannelList.countryTaxonomy))
          .then(({ data }) => {
            this.setState({ currentListCountries: data.responseData.classificationNodes })
          })
      })
      .catch((error) => { });
    this.loadCurrentState();
  }

  getProductTaxanomy = () => {
    let productDetails = this.props.productDetails;
    let account = productDetails.account;
    let echannel = productDetails.echannel;
    let achCredit = productDetails.achCredit;
    let cashFlowForecasting = productDetails.cashFlowForecasting

    taxonomyHostClient(this.translations(this.state.pageJson.par.navigation_list_eChannelList.countryTaxonomy))
      .then(({ data }) => {
        let currentListCountries = data.responseData.classificationNodes;

        if (account !== undefined) {
          account = account.map(item => {
            currentListCountries.filter(countItem => {
              if ('country' in item) {
                if (countItem.id === item.country.value) {
                  item.country.name = countItem.name
                }
              }
              return countItem;
            });
            productDetails.account = account;

            this.props.setProductsDetails(productDetails);
          });
        }

        if (echannel !== undefined) {
          echannel = echannel.map(item => {
            currentListCountries.filter(countItem => {
              if ('country' in item) {
                if (countItem.id === item.country.value) {
                  item.country.name = countItem.name
                }
              }
              return countItem;
            });
            productDetails.echannel = echannel;

            this.props.setProductsDetails(productDetails);
          });
        }

        if (achCredit !== undefined) {
          achCredit = achCredit.map(item => {
            currentListCountries.filter(countItem => {
              if ('country' in item) {
                if (countItem.id === item.country.value) {
                  item.country.name = countItem.name
                }
              }
              return countItem;
            });
            productDetails.achCredit = achCredit;

            this.props.setProductsDetails(productDetails);
          });
        }
        if (cashFlowForecasting !== undefined) {
          cashFlowForecasting = cashFlowForecasting.map(product => {
            currentListCountries.filter(country => {
              if ('country' in product) {
                if (country.id === product.country.value) {
                  product.country.name = country.name
                }
              }
              return country;
            });
            productDetails.cashFlowForecasting = cashFlowForecasting;
          });
          this.props.setProductsDetails(productDetails);
        }

      });
  }

  loadCurrentState = () => {
    this.props.blockUi();
    const allCaseIds = Object.keys(this.props.cases);
    var _caseId = allCaseIds[0];
    var glsAgent;
    var situation = "/singleEntity";
    if (allCaseIds.length > 1) {
      situation = "/multiEntity";
    }
    eapiClient("/product/all/case/" + _caseId + situation, { timeout: 420000 })
      .then(({ data, status }) => {
        this.props.setProductsDetails(data.responseData);
        this.getProductTaxanomy();
        this.props.updateDarkTitleBarCaseStatus(getProjectStatus(this.props.owningCase.caseId, data.responseData.caseStatuses));
        this.props.setTabsStatus('productRequestsTab', data.responseData.tabStatus === "complete");
        if (situation === "/multiEntity") {
          if (data.responseData.gls.length > 0) {
            glsAgent = data.responseData.gls[0].glsAgent;
            this.props.setGslAgent(glsAgent);
          } else {
            glsAgent = {}
            this.props.setGslAgent(glsAgent);
          }
        }
        const { caseStatuses } = data.responseData;
        this.props.updateCasesWithStatus(caseStatuses);
        // disable/enable generate draft button logic
        if (shoudlEnableGenerateDraftBtn(caseStatuses)) {
          this.props.enableCaseBodyFooterBtn('generateDocumentationBtn');
        } else {
          this.props.disableCaseBodyFooterBtn('generateDocumentationBtn');
        }
        // if(shoudlEnableGenerateDraftBtn(caseStatuses)) {
        //   this.props.enableCaseBodyFooterBtn('generateDocumentationBtn');
        // }else {
        //   this.props.disableCaseBodyFooterBtn('generateDocumentationBtn');
        // }
        // disable/enable cancel case button logic
        if (shoudlDisableCancelBtn(caseStatuses)) {
          this.props.disableCaseBodyFooterBtn('cancelBtn');
        } else {
          this.props.enableCaseBodyFooterBtn('cancelBtn');
        }
        // disable/enable Documentation tab logic
        if (shouldDisableDocumentationTab(caseStatuses)) {
          this.props.disableTab(2);
        } else {
          this.props.enableTab(2);
        }
        if (shoudlDisableAllCaseBodyFooterBtns(caseStatuses)) {
          this.props.disableAllCaseBodyFooterBtns();
        }
        this.props.unBlockUi();
      })
      .catch((error) => { });
  }

  redirectTopage = (event) => {
    if (event.target.value === 'New Account' || event.target.value === 'Rekening Baru' || event.target.value === 'nueva cuenta') {
      this.props.history.push("/case-body/create-new-account")
    } else if (event.target.value === 'E-Channel' || event.target.value === 'E-Channel' || event.target.value === 'canal electrónico') {
      if (this.props.customer) {
        this.props.history.push("/case-body/create-new-product-echannel")
      }
      else {
        this.props.history.push("/case-body/create-new-echannel")
      }

    } else if (event.target.value === 'GLS product' || event.target.value === 'produk GLS' || event.target.value === 'producto de GLS') {
      this.props.history.push("/case-body/create-new-glsproduct")
    } else if (event.target.value === 'ACH Credit Transfer' || event.target.value === 'Transfer Kredit ACH' || event.target.value === 'transferencia de crédito de ACH') {
      this.props.history.push("/case-body/add-ach-credit")
    } else if (event.target.value === 'Corporate Cards' || event.target.value === 'Tarjetas corporativas' || event.target.value === 'Kartu Kredit Perusahaan') {
      this.props.history.push("/case-body/add-corporate-card")
    }
    else if (event.target.value === 'Cash Flow Forecasting') {
      this.props.history.push("/case-body/add-cash-flow-forecasting")
    }
  }

  filterByEntity = (event) => {
    this.setState({ entityFilterSelection: event.target.value });
    var _caseId;
    var situation;
    var glsAgent;
    if (event.target.value === "all") {
      _caseId = Object.keys(this.props.cases)[0];
      situation = "/multiEntity";
    } else {
      _caseId = event.target.value;
      situation = "/singleEntity";
    }
    eapiClient("/product/all/case/" + _caseId + situation)
      .then(({ data, status }) => {
        this.props.setProductsDetails(data.responseData);
        if (situation === "/multiEntity") {
          if (data.responseData.gls.length > 0) {
            glsAgent = data.responseData.gls[0].glsAgent;
            this.props.setGslAgent(glsAgent);
          } else {
            glsAgent = {}
            this.props.setGslAgent(glsAgent);
          }
        }
        this.props.setTabsStatus('productRequestsTab', data.responseData.tabStatus === "complete");
        this.props.updateDarkTitleBarCaseStatus(getProjectStatus(this.props.owningCase.caseId, data.responseData.caseStatuses));
      })
      .catch((error) => { });
  }

  deleteProduct = (caseId, productType, productId) => {
    this.loadCurrentState();
  }

  onBannerClose = (bannerId) => {
    this.setState({
      bannersVisibility: { ...this.state.bannersVisibility, [bannerId]: true }
    });
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  toggleTooltip = () => {
    var selector = `[data-tooltip=add-product-dropdown]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=add-product-dropdown]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: !this.state.showTooltip
      })
    }
  }

  render() {
    const caseStatus = CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.status];
    const options = this.translateWord(this.props.productRequestJson.dropdown_addProduct.options)
    const productOptions = options.splice(0, 1);
    const { gls } = this.props.productDetails ? this.props.productDetails : {};
    if (Array.isArray(gls) && gls.length) {
      gls.forEach(product => {
        let { caseId } = product;
        if (CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.cases[caseId] && this.props.cases[caseId].status] > 2) {
          this.selectedEntity = true;
          return this.selectedEntity;
        }
      })
    }

    return (<div className="product-details-container">
      {
        this.props.customer && caseStatus < 3 &&
        <Banner
          bannerType="primary"
          actionText={this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.dropdown_addProduct.closeText) : 'Close'}
          bannerId="ci-customer-banner"
          actionCallback={this.onBannerClose}
          hide={this.state.bannersVisibility['ci-customer-banner']}
        >
          {
            this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.notification_CustomerProductRequestNotification.text) : ''
          }
        </Banner>
      }
      <div className="product-requests-action-bar clearfix">
        <div className="add-product-dropdown">
          <div className="posRel">
            <div className="dropDownArrowComponent">
              <span aria-hidden="true" className="alignVerLine">|</span>
              <span
                style={{ position: 'absolute', top: '4px' }}
                className={this.state.dropDownShow === true ? 'icon icon-chevron-up-small' : 'icon icon-chevron-down-small'}
              >
              </span>
            </div>
            <select
              className="custom-drop-down"
              value={productOptions[0]}
              onChange={this.redirectTopage}
              title={productOptions[0]}
            >
              <option disabled>
                {this.state.pageJson.par !== null && this.state.pageJson.par !== undefined ? productOptions[0] : ''}
              </option>
              {
                options.map((item, index) => (
                  <option
                    key={index}
                    value={item}
                    className={this.selectedEntity ? (item === 'GLS product' || item === 'Produk GLS' || item === 'Producto de GLS') ? 'gdocs-dropdown-value-disabled' : '' : ''}
                    disabled={(this.props.caseMenu.isEditing) ||
                      (this.selectedEntity ? (item === 'GLS product' || item === 'Produk GLS' || item === 'Producto de GLS') : false) ||
                      (this.props.customer && ((this.props.productDetails.account.length === 0 && (item === 'New Account' || item === 'Cuenta nueva' || item === 'Rekening Baru') || (item === 'GLS product' || item === 'Produk GLS' || item === 'Producto de GLS' || item === 'ACH Credit Transfer'
                        || item === 'Corporate Cards' || item === 'Tarjetas corporativas' || item === 'Kartu Kredit Perusahaan')) || item === 'Cash Flow Forecasting')
                      )}
                  >
                    {item}
                  </option>)
                )
              }
            </select>
            {
              (this.state.pageJson.par !== null && this.state.pageJson.par !== undefined)
                ? <button
                  className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon tooltip-add-product-dropdown-hint"
                  data-tooltip={"add-product-dropdown"}
                  onMouseEnter={this.toggleTooltip}
                  onMouseLeave={this.toggleTooltip}
                  onClick={this.toggleTooltip}
                  onKeyUp={(event) => this.toggleTooltiponEnter(event)}
                  aria-label={`Additional Information on ${productOptions[0]}`}
                  aria-expanded="false"
                  aria-describedby={`${"add-product-dropdown"}tooltip`}
                >
                </button>
                : ''
            }
            <Tooltip
              active={this.state.showTooltip}
              position="right"
              arrow="center"
              parent={"add-product-dropdown"}
            >
              <div className="tooltip-content-hintText" >
                <span role="status" id={`${"add-product-dropdown"}tooltip`}>{this.state.pageJson.par !== null && this.state.pageJson.par !== undefined ? Translations(this.state.pageJson.par.notification_ProductDropdownNotification.text, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}</span>
              </div>
            </Tooltip>
          </div>
        </div>
        {
          Object.keys(this.props.cases).length > 1 && !this.props.customer
            ? (<SimpleDropdown
              options={this.props.entitiesList}
              showPleaseSelectOption={false}
              value={this.state.entityFilterSelection}
              _onChange={this.filterByEntity}
              optionTextSelector="entityName"
              valueSelector="caseId"

            />)
            : ''
        }
      </div>
      {
        this.props.productDetails.account.length !== 0
          ? (<div className="account-list">
            {
              !this.props.customer ?
                <Banner
                  bannerType="primary"
                  actionText={this.state.pageJson.par !== undefined ? Translations(this.state.pageJson.par.notification_ProductRequestNotification.closeText, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
                  bannerId="ci-customer-banner"
                  actionCallback={this.onBannerClose}
                  hide={this.state.bannersVisibility['ci-customer-banner']}
                >
                  {this.state.pageJson.par !== undefined ? Translations(this.state.pageJson.par.notification_ProductRequestNotification.text, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
                </Banner> : ''
            }
            <p className="heading">
              {this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_accountList.title) : ''}
            </p>
            <NavigationList
              entities={this.props.entities}
              history={this.props.history}
              listtype="caseBodyProductRequests"
              pageReferer="newAccount"
              accountCountryList={this.state.currentListAccountCountries}
              cases={this.props.cases}
              productDetailsdata={this.props.productDetails}
              lang={this.props.lang}
              deleteProduct={this.deleteProduct}
              deleteModalContent={this.state.pageJson.par !== undefined ? this.state.pageJson.par.modal_account : {}}
            />
          </div>)
          : ''
      }
      {
        this.props.productDetails.gls.length !== 0
          ? (<div className="gls-list">
            <p className="heading">
              {this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_glsProducts.title) : ''}
            </p>
            <NavigationList
              entities={this.props.entities}
              history={this.props.history}
              listtype="caseBodyProductRequests"
              pageReferer="gls"
              options={this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_glsProducts.options) : ''}
              agentText={this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_glsProducts.agent) : ''}
              cases={this.props.cases}
              productDetailsdata={this.props.productDetails}
              lang={this.props.lang}
              deleteProduct={this.deleteProduct}
              deleteModalContent={this.state.pageJson.par !== undefined ? this.state.pageJson.par.modal_gls : {}}
            />
          </div>)
          : ''
      }
      {
        this.props.productDetails.achCredit.length !== 0
          ? (<div className="additional-data-list">
            <p className="heading">
              {this.state.pageJson.par !== undefined && this.state.pageJson.par.navigation_list_achCreditList !== undefined ? this.translations(this.state.pageJson.par.navigation_list_achCreditList.title) : ''}
            </p>
            <NavigationList
              entities={this.props.entities}
              history={this.props.history}
              listtype="caseBodyProductRequests"
              pageReferer="achCredit"
              cases={this.props.cases}
              countryList={this.state.currentListCountries}
              productDetailsdata={this.props.productDetails}
              lang={this.props.lang}
              deleteProduct={this.deleteProduct}
              deleteModalContent={this.state.pageJson.par !== undefined ? this.state.pageJson.par.modal_ach : {}}
              achPaymentModalContent={this.props.achPaymentTypeModalJson.par !== undefined ? this.props.achPaymentTypeModalJson.par : {}}
              reloadProductRequests={this.loadCurrentState}
            />
          </div>)
          : ''
      }
      {
        (Array.isArray(this.props.productDetails.cashFlowForecasting) && this.props.productDetails.cashFlowForecasting.length)
          ? (<div className="cash-flow-forecasting">
            <p className="heading">
              {this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_cashFlowForecastingProducts.title) : ''}
            </p>
            <NavigationList
              entities={this.props.entities}
              history={this.props.history}
              listtype="caseBodyProductRequests"
              pageReferer="cashFlowForecasting"
              cases={this.props.cases}
              countryList={this.state.currentListCountries}
              productDetailsdata={this.props.productDetails}
              lang={this.props.lang}
              deleteProduct={this.deleteProduct}
              deleteModalContent={this.state.pageJson.par !== undefined ? this.state.pageJson.par.modal_cashflowforecasting : {}}
            />
          </div>)
          : ''
      }
      {
        this.props.productDetails.echannel.length !== 0
          ? (<div className="echannel-list">
            <p className="heading">
              {this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_eChannelList.title) : ''}
            </p>
            <NavigationList
              entities={this.props.entities}
              history={this.props.history}
              listtype="caseBodyProductRequests"
              pageReferer="echannel"
              cases={this.props.cases}
              countryList={this.state.currentListCountries}
              newEchannelKey={this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_eChannelList.new) : ''}
              existingEchannelKey={this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_eChannelList.existing) : ''}
              productDetailsdata={this.props.productDetails}
              lang={this.props.lang}
              deleteProduct={this.deleteProduct}
              deleteModalContent={this.state.pageJson.par !== undefined ? this.state.pageJson.par.modal_echannel : {}}
            />
          </div>)
          : ''
      }
      {
        this.props.productDetails.corporateCard !== undefined && this.props.productDetails.corporateCard.length !== 0
          ? (<div className="corporate-list">
            <p className="heading">
              {this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_corporateCardProducts.title) : ''}
            </p>
            <NavigationList
              entities={this.props.entities}
              history={this.props.history}
              listtype="caseBodyProductRequests"
              pageReferer="corporateCard"
              cases={this.props.cases}
              countryList={this.state.currentListCountries}
              productDetailsdata={this.props.productDetails}
              lang={this.props.lang}
              deleteProduct={this.deleteProduct}
              deleteModalContent={this.state.pageJson.par !== undefined ? this.state.pageJson.par.modal_coroporatecards : {}}
            />
          </div>)
          : ''
      }
      {
        this.props.productDetails.additionalData.length !== 0
          ? (<div className="additional-data-list">
            <p className="heading">
              {this.state.pageJson.par !== undefined ? this.translations(this.state.pageJson.par.navigation_list_countryForms.title) : ''}
            </p>
            <NavigationList
              entities={this.props.entities}
              history={this.props.history}
              listtype="caseBodyProductRequests"
              pageReferer="additionalData"
              cases={this.props.cases}
              productDetailsdata={this.props.productDetails}
            />
          </div>)
          : ''
      }
    </div>
    );
  }
}

const mapStateToProps = state => {
  let entitiesList = [];
  entitiesList = (Object.keys(state.entities)).map(entityId => {
    const { caseId, entityName } = state.entities[entityId];
    return { entityId, caseId, entityName };
  });
  entitiesList.unshift({
    caseId: 'all',
    entityName: 'All'
  });
  return {
    cases: state.cases,
    customer: state.auth.userDetails.roleDetails.customer,
    caseMenu: state.caseMenuInfo,
    status: electOwningCase(state.cases).status,
    productDetails: state.productDetails,
    entities: state.entities,
    owningCase: electOwningCase(state.cases),
    entitiesList,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setProductsDetails: productsDetailsdata => {
      dispatch(setProductsDetails(productsDetailsdata))
    },
    setTabsStatus: (tabName, isComplete) => {
      dispatch(setTabsStatus(tabName, isComplete))
    },
    setGslAgent: (glsAgentData) => {
      dispatch(setGslAgent(glsAgentData))
    },
    enableTab: (tabName) => {
      dispatch(enableTab(tabName))
    },
    disableTab: (tabName) => {
      dispatch(disableTab(tabName))
    },
    disableAllCaseBodyFooterBtns: () => {
      dispatch(disableAllCaseBodyFooterBtns())
    },
    updateDarkTitleBarCaseStatus: caseStatus => {
      dispatch(updateDarkTitleBarCaseStatus(caseStatus))
    },
    enableCaseBodyFooterBtn: (btnName) => {
      dispatch(enableCaseBodyFooterBtn(btnName))
    },
    disableCaseBodyFooterBtn: (btnName) => {
      dispatch(disableCaseBodyFooterBtn(btnName))
    },
    updateCasesWithStatus: (caseStatuses) => {
      dispatch(updateCasesWithStatus(caseStatuses));
    },
    resetCurrentProductAch: () => {
      dispatch(resetCurrentProductAch());
    },
    resetcurrentProductCorporateCard: () => {
      dispatch(resetcurrentProductCorporateCard());
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductRequests);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/index.js